import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../domain';
import {StaticImageModel} from './models';

interface Props {
  x9: X9Content | X9ContentSnapshot;
}

@observer
export class X9StaticImageView extends React.Component<Props> {
  render() {
    const {Contents} = this.props.x9;
    const model = JSON.parse(Contents) as StaticImageModel;
    return (
      <div className="row">
        <div className="col">
          <div className="static-image-container">
            <img className="static-image" alt=" Image not found" src={model.imageUrl} />
          </div>
        </div>
      </div>);
  }
}
